/**
 * Ссылка «редактировать акцию» в кабинете.
 *
 * Как в старом шаблоне: `edit_link` и суперпользователь либо владелец клиники.
 */
export default function canEditLpuPromotion({
  isMobile,
  editLink,
  isSuperuser,
  user2Id,
  ownerId,
}: {
  isMobile: boolean
  editLink?: boolean
  isSuperuser?: boolean
  user2Id?: number
  ownerId?: number
}): boolean {
  if (isMobile || !editLink) {
    return false
  }

  if (isSuperuser) {
    return true
  }

  return user2Id != null && ownerId != null && user2Id === ownerId
}
